<div
  class="w-100"
  [hidden]="state.hidden && (!forceShow || state.defaultValue === null)"
  [attr.data-automation]="config.dataAutomation"
  [ngClass]="{
    'active-color': isFileOver,
    'disabled-color': state.disabled,
    'has-feedback': showValidation || isFormSubmitted,
    'ziro-forms-error': validationState === ValStates.INVALID,
    'ziro-forms-warning':
      validationState === ValStates.PENDING || validationState === ValStates.WARNING || misconfigurationFeedbackMessage,
    'ziro-forms-success': validationState === ValStates.VALID && showAsyncValidation,
  }"
>
  <div
    class="position-relative tooltip-wrapper d-block mb-3"
    ziroFileUploader
    (fileOver)="onFileOver($event)"
    (fileDropped)="handleFiles($event)"
    (click)="fileInput.click()"
    data-automation="file-uploader-overlay"
    [ngbTooltip]="getDisabledTooltip()?.content | translate: getDisabledTooltip()?.params"
    [container]="'body'"
    [disableTooltip]="!state.disabled"
  >
    @if (state.required && getLabel()) {
      <span class="text-danger ziro-forms-label col-form-label required-label ziro-forms-asterisk">
        *
        <span class="uploader-label">
          {{ getLabel() | translate }}
        </span>
      </span>
    }

    @if (state.disabled) {
      <div
        class="disabled-background tooltip-wrapper"
        [ngbTooltip]="getDisabledTooltip()?.content | translate: getDisabledTooltip()?.params"
        [container]="'body'"
        [disableTooltip]="!state.disabled"
      ></div>
    }

    <svg viewBox="0 0 300 100" preserveAspectRatio="none">
      <path
        d="M0,0 300,0 300,100 0,100z"
        vector-effect="non-scaling-stroke"
        [ngClass]="{
          'disabled-stroke': state.disabled,
          'has-feedback': showValidation || isFormSubmitted,
          'feedback-stroke': showValidation || isFormSubmitted,
          'error-stroke': validationState === ValStates.INVALID,
          'warning-stroke':
            validationState === ValStates.PENDING ||
            validationState === ValStates.WARNING ||
            misconfigurationFeedbackMessage,
          'success-stroke': validationState === ValStates.VALID && showAsyncValidation,
          'active-stroke': isFileOver,
        }"
      />
    </svg>

    <div class="w-100 p-4 d-flex flex-column justify-content-center align-items-center">
      @if (validationState === ValStates.PENDING) {
        <i [attr.data-automation]="'ziro-text-async-pending'" [ngClass]="ziroIcons.SAVING" class="fa fa-4x d-block"></i>
      }
      @if (validationState !== ValStates.PENDING) {
        <i [ngClass]="ziroIcons.IMPORT" class="fa-4x d-block text-primary"></i>
      }
      <div class="text-center">
        <div [innerHTML]="'tkey;forms.file.uploader.title' | escapeHtml"></div>
        <input
          data-automation="file-uploader-input"
          type="file"
          multiple
          id="uploader"
          (change)="handleFiles($event.target.files)"
          [accept]="acceptedFileExtensions?.acceptedExtensions || null"
          #fileInput
          [disabled]="state.disabled"
        />
        <button
          type="button"
          class="btn btn-border btn-outline-primary file-btn"
          [attr.data-automation]="'choose-file-btn'"
          [ngClass]="{
            'disabled-button': state.disabled,
          }"
        >
          {{ 'tkey;forms.file.uploader.button' | translate }}
        </button>
        <div class="pt-2 d-flex justify-content-center gap-2">
          @if (!!formattedSize) {
            <span>{{ 'tkey;forms.file.uploader.max_size' | translate }}{{ formattedSize }}</span>
          }
          @if (!!formattedAcceptedFields) {
            <span>{{ 'tkey;forms.file.uploader.accepted_files' | translate }}{{ formattedAcceptedFields }}</span>
          }
        </div>

        <div class="form-feedback pt-2">
          <span>
            @if (validationState === ValStates.INVALID && showAsyncValidation) {
              <i class="{{ ziroIcons.REMOVE }}" data-automation="ziro-text-async-invalid"></i>
            }
            @if (validationState === ValStates.VALID && showAsyncValidation) {
              <i class="{{ ziroIcons.SAVE_SUCCESS }} " data-automation="ziro-text-async-valid"></i>
            }
          </span>
        </div>

        <div class="ziro-forms-feedback-area">
          <div
            class="ziro-forms-validation-message"
            data-automation="ziro-forms-validation-message"
            [hidden]="!showValidation && !isFormSubmitted"
          >
            {{ validationMessage?.content | translate: validationMessage?.params }}
          </div>

          <div
            class="ziro-forms-validation-message text-warning"
            data-automation="ziro-forms-warning-message"
            [hidden]="!misconfigurationFeedbackMessage"
          >
            {{ misconfigurationFeedbackMessage?.content | translate: misconfigurationFeedbackMessage?.params }}
          </div>

          @if (config.helpText) {
            <span class="small form-text text-muted">
              {{ getHelpText() | translate }}
            </span>
          }
        </div>
      </div>
    </div>
  </div>

  @if (uploaderType === UploaderType.STAGED) {
    <div class="w-100 d-flex flex-column gap-2" [ngClass]="{ 'pb-3': !!files.length }">
      @for (file of files; track file; let index = $index) {
        <div
          class="file position-relative px-3 py-2 d-flex gap-4 align-items-center"
          [ngClass]="{
            'border-danger': invalidFileIds.includes(file.id),
            'text-body': !invalidFileIds.includes(file.id),
          }"
          [attr.data-automation]="'file-' + index"
        >
          <i [ngClass]="ziroIcons.FILE" class="fa fa-2xd-block"></i>
          <div class="d-flex align-items-center me-auto">
            <p class="mb-0">
              <span data-automation="file-name">{{ file.file.name }}</span>
              <span class="font-sml-grey d-block" data-automation="file-subtext">{{ getStagedFileSubtext(file) }}</span>
            </p>
          </div>
          <ziro-button
            [dataAutomation]="'delete-btn'"
            [isDisabled]="state.disabled"
            [cssClass]="'btn-sm ms-1'"
            [icon]="ziroIcons.DELETE_SMALL"
            [buttonStyle]="ButtonStyles.OUTLINE_DANGER"
            [type]="ButtonTypes.BUTTON"
            (clicked)="onDeleteFile(file.id)"
          ></ziro-button>
        </div>
      }
    </div>
  }

  <div>
    @if ((uploaderType === UploaderType.TABLE && !!tableRows().length) || showTable()) {
      <ziro-datatable
        [class]="'ziro-card'"
        class="file-uploader-datatable"
        [uniqueRowIdentifier]="uniqueRowIdentifier()"
        [dataAutomation]="'file-uploader-datatable'"
        [columns]="columns"
        [rowDataSource]="tableRows()"
      ></ziro-datatable>
    }
  </div>
</div>
